import createSliders from './create-slider.js';

function init() {
    const options = {
        spaceBetween: 16,
        slidesPerView: 4,
        watchOverflow: true,
        watchSlidesProgress: true,
        freeMode: false,
        breakpoints: {
            0: {
                freeMode: true,
                slidesPerView: 1,
            },
            671: {
                slidesPerView: 2,
            },
            801: {
                slidesPerView: 3,
            },
            1201: {
                slidesPerView: 4,
            },
        },
    };

    createSliders('js_featuredJobs', options);
}

$(document).ready(init);
